import { Utils } from '@Util/utils'
import { ANIMATION_IDENTIFIERS } from './types'
import { store } from '@AppState/redux-store'
1
export const tweenPromise = (
  scene: Phaser.Scene,
  config: Phaser.Types.Tweens.TweenBuilderConfig,
): (() => Promise<void>) => {
  return () => {
    return new Promise((resolve) => {
      if (scene) {
        scene.tweens.add({
          ...config,
          onComplete: () => resolve(),
        })
      }
    })
  }
}

export const counterPromise = (
  scene: Phaser.Scene,
  config: Phaser.Types.Tweens.NumberTweenBuilderConfig,
): (() => Promise<void>) => {
  return () => {
    return new Promise((resolve) => {
      if (scene) {
        scene.tweens.addCounter({
          ...config,
          onComplete: () => resolve(),
        })
      }
    })
  }
}

export const tweenWaitPromise = (scene: Phaser.Scene, waitMs: number): (() => Promise<void>) => {
  return () => {
    return new Promise((resolve) => {
      if (scene) {
        scene.tweens.addCounter({
          duration: waitMs,
          onComplete: () => resolve(),
        })
      }
    })
  }
}

export const selectAnimationIdentifier = () => {
  const animationsEnabled = store.getState().appSettings.appSettings.animationsEnabled
  if (animationsEnabled.length === 0) {
    return ANIMATION_IDENTIFIERS.DEFAULT
  }
  const filteredAnimations = animationsEnabled.filter((anim) => anim.isEnabled)

  if (filteredAnimations.length === 0) {
    return animationsEnabled[0].identifier
  }

  return Utils.getRandomElementFromArray(filteredAnimations).identifier
}
